import React from 'react'
import Layout from '../components/global/Layout'
import Hero from '../components/guide/Hero/Hero'

const Survey = () => {

    const content = {
        subtitle: 'Survey',
        title: 'Lengkapi Survey Untuk Tingkatkan Kualitas',
        image: '/assets/image/guide/untuk ortu.png',
        vector: '/assets/image/guide/vectorForParent.png',
        description: 'Partisipasi dalam survei ini akan membantu dalam memahami apa yang berjalan baik dan di mana kita bisa melakukan perbaikan'
    }
    
    return (
        <Layout>
            <Hero content={content} role="parent" />
            <section className='my-5'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="card border-0 shadow-sm rounded p-3 h-100 d-flex flex-column">
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    <img src="/assets/image/guide/survey/brown.svg" alt="" />
                                    <h6 className='mb-0'>Instrumen untuk Responden Kepala Sekolah 2026</h6>
                                </div>

                                <button className="btn btn-outline-primary btn-lg btn-block mt-auto" onClick={() => window.open('https://survei.bukupusbuk.id/s/2026ks', '_blank')}>Lihat selengkapnya &#8594;</button>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="card border-0 shadow-sm rounded p-3 h-100 d-flex flex-column">
                                <div className="d-flex align-items-center gap-2">
                                    <img src="/assets/image/guide/survey/red.svg" alt="" />
                                    <h6 className='mb-0'>Instrumen untuk Responden Guru 2026</h6>
                                </div>

                                <button className="btn btn-outline-primary btn-lg btn-block mt-auto" onClick={() => window.open('https://survei.bukupusbuk.id/s/2026g', '_blank')}>Lihat selengkapnya &#8594;</button>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="card border-0 shadow-sm rounded p-3 h-100 d-flex flex-column">
                                <div className="d-flex align-items-center gap-2">
                                    <img src="/assets/image/guide/survey/purple.svg" alt="" />
                                    <h6 className='mb-0'>Instrumen untuk Responden Siswa 2026</h6>
                                </div>

                                <button className="btn btn-outline-primary btn-lg btn-block mt-auto" onClick={() => window.open('https://survei.bukupusbuk.id/s/2026s', '_blank')}>Lihat selengkapnya &#8594;</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default Survey